import api from './api';

// Jobs API Functions
export const getJobs = async (params = {}) => {
  try {
    console.log("=== FETCHING JOBS ===");
    console.log("Request params:", params);
    
    const res = await api.get('/api/careers/jobs', { params });
    console.log("Jobs received:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR FETCHING JOBS ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const getJobById = async (id) => {
  try {
    console.log("=== FETCHING JOB BY ID ===");
    console.log("Job ID:", id);
    
    const res = await api.get(`/api/careers/jobs/${id}`);
    console.log("Job received:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR FETCHING JOB ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const createJob = async (data) => {
  try {
    console.log("=== CREATING JOB ===");
    console.log("Job data:", data);
    
    const res = await api.post('/api/careers/jobs', data);
    console.log("Job created successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR CREATING JOB ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const updateJob = async (id, data) => {
  try {
    console.log("=== UPDATING JOB ===");
    console.log("Job ID:", id);
    console.log("Update data:", data);
    
    const res = await api.put(`/api/careers/jobs/${id}`, data);
    console.log("Job updated successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPDATING JOB ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteJob = async (id) => {
  try {
    console.log("=== DELETING JOB ===");
    console.log("Job ID:", id);
    
    const res = await api.delete(`/api/careers/jobs/${id}`);
    console.log("Job deleted successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR DELETING JOB ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

// Job Applications API Functions
export const getJobApplications = async (params = {}) => {
  try {
    console.log("=== FETCHING JOB APPLICATIONS ===");
    console.log("Request params:", params);
    
    const res = await api.get('/api/careers/applications', { params });
    console.log("Applications received:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR FETCHING APPLICATIONS ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const getJobApplicationById = async (id) => {
  try {
    console.log("=== FETCHING APPLICATION BY ID ===");
    console.log("Application ID:", id);
    
    const res = await api.get(`/api/careers/applications/${id}`);
    console.log("Application received:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR FETCHING APPLICATION ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const updateApplicationStatus = async (id, status) => {
  try {
    console.log("=== UPDATING APPLICATION STATUS ===");
    console.log("Application ID:", id);
    console.log("New status:", status);
    
    const res = await api.put(`/api/careers/applications/${id}/status`, { status });
    console.log("Application status updated successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPDATING APPLICATION STATUS ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};

export const applyToJob = async (jobId, formData) => {
  try {
    console.log("=== APPLYING TO JOB ===");
    console.log("Job ID:", jobId);
    console.log("Application data:", formData);
    
    const res = await api.post(`/api/careers/jobs/${jobId}/apply`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log("Application submitted successfully:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR SUBMITTING APPLICATION ===");
    console.error("Error details:", error.response?.data || error.message);
    throw error;
  }
};
